export default __webpack_public_path__ + "atomic/_patterns/01-atoms/grid/_grid--1-up.twig";